import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

import Async from 'components/Async';
import Authenticated from 'components/Authenticated';
import ScrollToTop from 'components/ScrollToTop';

import DashboardLayout from './layouts/Dashboard';
// import LandingLayout from "./layouts/Landing";
import AuthLayout from './layouts/Auth';
import NotFoundPage from 'containers/NotFoundPage';

import { routesByRole } from './routes';
import { createStructuredSelector } from 'reselect';
import { makeSelectUserRole } from './selectors';

ReactGA.initialize(process.env.REACT_APP_GA_ID);
const subpageRegex = new RegExp('^(/[^/]+)/[0-9]+/(.*)');

export const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    if (subpageRegex.test(page)) {
      page = page.replace(subpageRegex, '$1/:id/$2');
    }

    ReactGA.set({ page, ...options });
    ReactGA.pageview(page);
  };

  const HOC = props => {
    useEffect(() => trackPage(props.location.pathname), [props.location.pathname]);

    return <WrappedComponent {...props} />;
  };

  return HOC;
};

const AsyncWithTracker = withTracker(Async);

const routeRenderer = (Layout = DashboardLayout, pageComponent, noAuth) => props => {
  return noAuth ? (
    <Layout>
      <AsyncWithTracker page={pageComponent} {...props} />
    </Layout>
  ) : (
    <Authenticated {...props}>
      <Layout>
        <AsyncWithTracker page={pageComponent} {...props} />
      </Layout>
    </Authenticated>
  );
};

const App = props => {
  const availabelRoutes = routesByRole(props.userRole);

  useEffect(() => {
    localStorage.removeItem('NOT_REGISTERED_PACKAGE');
    return () => {
      localStorage.removeItem('NOT_REGISTERED_PACKAGE');
    };
  }, []);
  return (
    <ScrollToTop>
      <Helmet titleTemplate="%s - Parousya SAAS" defaultTitle="Parousya SAAS">
        <meta name="description" content="Parousya SAAS Administration" />
      </Helmet>
      <Switch>
        {availabelRoutes.map(({ noAuth, children, path, pageComponent, layout }, index) =>
          children ? (
            // Route item with children
            children.map(({ path, pageComponent }, index) => (
              <Route key={index} path={path} exact render={routeRenderer(layout, pageComponent, noAuth)} />
            ))
          ) : (
            // Route item without children
            <Route key={index} path={path} exact render={routeRenderer(layout, pageComponent, noAuth)} />
          ),
        )}

        <Route
          render={() => (
            <AuthLayout>
              <NotFoundPage />
            </AuthLayout>
          )}
        />
      </Switch>
      <ToastContainer
        autoClose={3000}
        transition={Slide}
        pauseOnHover
        closeOnClick
        newestOnTop
        position={toast.POSITION.TOP_RIGHT}
      />
    </ScrollToTop>
  );
};

const mapStateToProps = createStructuredSelector({
  userRole: makeSelectUserRole(),
});

export default connect(mapStateToProps)(App);
